import { render, staticRenderFns } from "./BrandBanner.vue?vue&type=template&id=19d94420&scoped=true"
import script from "./BrandBanner.vue?vue&type=script&lang=js"
export * from "./BrandBanner.vue?vue&type=script&lang=js"
import style0 from "./BrandBanner.vue?vue&type=style&index=0&id=19d94420&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d94420",
  null
  
)

export default component.exports